import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import { FaWallet, FaSignOutAlt, FaTrophy, FaUser } from "react-icons/fa";
import RecentGames from "./RecentGames";

/* ===== Only these avatars are allowed (use exact filenames placed in your public/assets/avtars folder) ===== */
const avatars = [
  "/assets/avtars/avtar1.png",
  "/assets/avtars/avtar2.jpg",
  "/assets/avtars/avtar4.jpg",
  "/assets/avtars/avtar5webp.jpg",
  "/assets/avtars/avtar6.jpg",
];

function MyAccount() {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedAvatar, setSelectedAvatar] = useState(
    () => localStorage.getItem("selectedAvatar") || avatars[0]
  );

  useEffect(() => {
    localStorage.setItem("selectedAvatar", selectedAvatar);
  }, [selectedAvatar]);

useEffect(() => {
  const subscribed = localStorage.getItem("isSubscribed");

  if (subscribed !== "true") {
    navigate("/signin");
  }
}, [navigate]);


const [user, setUser] = useState(
  JSON.parse(localStorage.getItem("user")) || {
    firstName: "",
    lastName: "",
    dob: "",
    gender: "",
    country: "",
    city: "",
    phone: "",
    email: "",
  }
);

  const logout = () => {
    localStorage.clear();
    navigate("/signin");
  };

const handleChange = (e) => {
  setUser({
    ...user,
    [e.target.name]: e.target.value,
  });
};

const handleSave = () => {

  if (
    !user.firstName ||
    !user.lastName ||
    !user.email ||
    !user.phone
  ) {
    Swal.fire({
      icon: "error",
      title: "Validation Error",
      text: "Please fill all required fields",
    });

    return;
  }

  localStorage.setItem("user", JSON.stringify(user));

  Swal.fire({
    icon: "success",
    title: "Success",
    text: "Your account is updated successfully",
    confirmButtonColor: "#facc15",
  });
};

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-[#0e0e1a] text-white">
      {/* ================= BANNER ================= */}
      <div
        className="relative w-full h-[240px] bg-cover bg-center"
        style={{ backgroundImage: "url('/assets/account-banner-bg.png')" }}
      >
        <div
          className="relative h-full max-w-[1200px] mx-auto mb-25"
          style={{ padding: "30px 40px" }}
        >
          <div className="flex justify-between items-end h-full pb-6">
            <h1 className="text-2xl font-bold">Hello, Welcome!</h1>
            <p className="text-gray-300 text-sm">Last session start: 1 Dec 2025, 09:26</p>
          </div>
        </div>
      </div>

      {/* ================= PAGE CONTENT ================= */}
      <div className="max-w-[1200px] mx-auto px-5 py-10 -mt-20 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* ================= LEFT SIDEBAR ================= */}
          <div className="space-y-6">
            <div className="bg-[#2f3147] rounded-2xl p-6 space-y-4">
              <MenuBtn
                icon={<FaUser />}
                text="Dashboard"
                active={isActive("/myaccount")}
                onClick={() => navigate("/myaccount")}
              />

             

              <MenuBtn
  icon={<FaTrophy />}
  text="Leaderboard"
/>

              <div className="border-t border-gray-600 my-4" />

              <button
                onClick={logout}
                className="w-full flex items-center justify-center gap-2 bg-[#50506d] py-3 rounded-xl hover:bg-[#5d5f7a] transition"
              >
                <FaSignOutAlt /> Signout
              </button>
            </div>

            {/* NEED HELP */}
            <div className="bg-[#3b3d57] rounded-2xl p-6 text-center">
              <div className="w-20 h-20 mx-auto rounded-full bg-[#4a4c68] flex items-center justify-center mb-4">
                <span className="text-yellow-400 text-4xl">💬</span>
              </div>

              <h3 className="text-xl font-bold mb-2">Need Help?</h3>
              <p className="text-gray-300 text-sm mb-4">Have questions or concerns regarding your account?</p>

              <button
  onClick={() => navigate("/support")}
  className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold px-6 py-2 rounded-xl transition"
>
  Chat with Us
</button>
            </div>
          </div>

          {/* ================= RIGHT CONTENT ================= */}
          <div className="lg:col-span-3 space-y-6">
            {/* BALANCE */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <BalanceCard title="Available Balance" amount="0.00 GHS" />
              <BalanceCard title="Affiliate Balance" amount="0.00 GHS" />
            </div>

            {/* ================= PROFILE INFO (UPDATED) ================= */}
            <div className="bg-[#2f3147] rounded-2xl p-6">
             
              {/* Avatar Selection (ONLY predefined avatars allowed) */}
              <div className="mb-8">
                <label className="block mb-3 font-medium text-white">Profile Avatar</label>

                {/* Selected Avatar */}
                <div className="flex items-center gap-6 bg-[#40425c] p-4 rounded-xl border border-gray-600 mb-4">
                  <img
                    src={selectedAvatar}
                    alt="selected avatar"
                    className="w-20 h-20 rounded-full object-cover border-2 border-yellow-400"
                  />

                  <p className="text-sm text-gray-300">Select one of the avatars below</p>
                </div>

                {/* Avatar Options */}
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
                  {avatars.map((avatarUrl, index) => (
                    <button
                      key={index}
                      type="button"
                      onClick={() => setSelectedAvatar(avatarUrl)}
                      className={`rounded-full p-1 transition-all transform ${
                        selectedAvatar === avatarUrl ? "scale-105 ring-2 ring-yellow-400" : "hover:scale-105"
                      }`}
                      aria-label={`Choose avatar ${index + 1}`}
                    >
                      <img
                        src={avatarUrl}
                        alt={`avatar-${index}`}
                        className="w-16 h-16 rounded-full object-cover"
                      />
                    </button>
                  ))}
                </div>
              </div>

              {/* Profile Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
               <Field
  label="First Name"
  name="firstName"
  value={user.firstName}
  onChange={handleChange}
/>
                <Field label="Last Name" name="lastName" value={user.lastName} onChange={handleChange} />

<Field label="Date Of Birth" name="dob" value={user.dob} onChange={handleChange} />

<Field label="Gender" name="gender" value={user.gender} onChange={handleChange} />

<Field label="Country" name="country" value={user.country} onChange={handleChange} />

<Field label="City" name="city" value={user.city} onChange={handleChange} />

<Field label="Phone Number" name="phone" value={user.phone} onChange={handleChange} />

<Field label="Email" name="email" value={user.email} onChange={handleChange} />
              </div>

              <div className="mt-8 flex justify-between items-center">
  <h3 className="text-xl font-bold">Change Password</h3>

  <span className="cursor-pointer text-gray-300 hover:text-yellow-400">
    ✎
  </span>
</div>

<div className="mt-8">
  <button
    onClick={handleSave}
    className="bg-yellow-400 hover:bg-yellow-500 text-black font-bold px-8 py-3 rounded-xl transition"
  >
    Save Changes
  </button>
</div>

           </div>
          </div>
        </div>

       

      </div>
    </div>
  );
}

/* ================= REUSABLE COMPONENTS ================= */

const MenuBtn = ({ icon, text, active, onClick }) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center gap-3 py-3 px-4 rounded-xl transition
      ${active ? "border border-yellow-400 bg-[#40425c]" : "bg-[#40425c] hover:bg-[#4a4c68]"}`}
  >
    {icon}
    <span>{text}</span>
  </button>
);

const BalanceCard = ({ title, amount }) => (
  <div className="bg-[#2f3147] rounded-2xl p-6 flex justify-between items-center">
    <div className="flex items-center">
      <div className="w-16 h-16 rounded-full bg-[#4a4c68] flex items-center justify-center">
        <FaWallet className="text-white text-3xl" />
      </div>
      <div className="ml-4">
        <p className="text-green-400 text-2xl font-bold">{amount}</p>
        <p className="text-gray-300">{title}</p>
      </div>
    </div>
    <span className="text-yellow-400 text-2xl">➜</span>
  </div>
);

const Field = ({ label, value, name, onChange }) => (
  <div>
    <label className="block mb-2 font-medium">{label}</label>
    <input
  name={name}
  value={value}
  onChange={onChange}
  className="w-full bg-[#40425c] px-4 py-3 rounded-xl text-white outline-none"
/>
  </div>
);

export default MyAccount;
